/** @deprecated Use cookie helpers below. Kept for localStorage → cookie migration. */
export const LANG_KEY = 'vacant-day-lang-override';

/** localStorage key for the user's origin/home country */
export const ORIGIN_KEY = 'vacant-day-origin-country';

// ---------------------------------------------------------------------------
// Language preference cookie (replaces localStorage for server-side access)
// ---------------------------------------------------------------------------

/** Cookie name for language preference — readable by Next.js middleware */
export const LANG_COOKIE = 'lang-pref';

const ONE_YEAR = 365 * 24 * 60 * 60; // seconds

/** Read the user's language preference (cookie, with localStorage migration) */
export function getLangPref(): string | null {
  if (typeof document === 'undefined') return null;

  // Read from cookie
  const match = document.cookie.match(new RegExp(`(?:^|; )${LANG_COOKIE}=([^;]*)`));
  if (match) return decodeURIComponent(match[1]);

  // Migrate from localStorage (one-time)
  try {
    const legacy = localStorage.getItem(LANG_KEY);
    if (legacy) {
      setLangPref(legacy);
      localStorage.removeItem(LANG_KEY);
      return legacy;
    }
  } catch {
    // localStorage blocked — ignore
  }

  return null;
}

/** Set the user's explicit language preference */
export function setLangPref(lang: string): void {
  if (typeof document === 'undefined') return;
  document.cookie = `${LANG_COOKIE}=${encodeURIComponent(lang)}; path=/; max-age=${ONE_YEAR}; SameSite=Lax`;
}

/** Clear the language preference (revert to auto-detect) */
export function clearLangPref(): void {
  if (typeof document === 'undefined') return;
  document.cookie = `${LANG_COOKIE}=; path=/; max-age=0; SameSite=Lax`;
}
